import Vue from 'vue';
import { ApolloLink, from, HttpLink, InMemoryCache } from 'apollo-boost';
import { ApolloClient } from 'apollo-client';
import VueApollo from 'vue-apollo';

import { LocalStorage } from './enums/storage.enum';
import { config } from './utils/config';
import store from './store';
import router from './router';
import { UNAUTHORIZED_MESSAGES } from './utils/constants';

Vue.use(VueApollo);

const httpLink = new HttpLink({ uri: config.graphQLURL });

const tokenApplyMiddleware = new ApolloLink((operation, forward) => {
  if (forward) {
    const token = localStorage.getItem(LocalStorage.TOKEN);
    if (token) {
      operation.setContext({
        headers: {
          authorization: `Bearer ${token}`
        }
      });
    }
    return forward(operation);
  }
  return null;
});

const tokenRefreshMiddleware = new ApolloLink((operation, forward) => {
  if (forward) {
    return forward(operation).map(response => {
      const context = operation.getContext();
      const headers = context.response.headers;
      if (headers) {
        const newToken = headers.get('token');
        if (newToken) {
          localStorage.setItem(LocalStorage.TOKEN, newToken);
        }
      }

      return response;
    });
  }
  return null;
});

const unauthorizedMiddleware = new ApolloLink((operation, forward) => {
  if (forward) {
    return forward(operation).map(response => {
      if (
        response.errors &&
        response.errors.some(graphQlError => UNAUTHORIZED_MESSAGES.includes(graphQlError.message))
      ) {
        store.dispatch('auth/unauthorize').then(() => router.push({ name: 'login' }));
      }

      return response;
    });
  }
  return null;
});

export const apolloClient = new ApolloClient({
  cache: new InMemoryCache({ resultCaching: false }),
  link: from([unauthorizedMiddleware, tokenApplyMiddleware, tokenRefreshMiddleware, httpLink])
});

const apolloProvider = new VueApollo({ defaultClient: apolloClient });

export default apolloProvider;
